import React, { Component } from "react";

export default class Approach extends Component {
  render() {
    return (
      <div>
        <section className="section-approach" id="features">
          <div className="row">
            <div className="col-sm-12">
              <h2>OUR APPROACH</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-6 approachSegments">
              <div className="row innerRow">
                <div className="col-md-6 approachSegment">
                  <img
                    src={require("../../assets/img/grow_predictably.png")}
                    alt="Icon"
                  />
                  <h3>PREDICTABLE RESULTS</h3>
                  <p>
                    Every project begins with understanding your business goals,
                    budget and timeline. We follow a formal and collaborative
                    Agile development approach that starts with a concept phase
                    to identify your business needs, locate any gaps, and follow
                    through with two week development cycles to incrementally
                    deploy a POC, MVP, and full solution that meets all of the
                    stakeholder’s objectives.
                  </p>
                </div>
                <div className="col-md-6 approachSegment">
                  <img
                    src={require("../../assets/img/grow_sustainably.png")}
                    alt="Icon"
                  />
                  <h3>MAINTAINABLE SOLUTIONS</h3>
                  <p>
                    Our highly configurable cloud platform and extensive code
                    library allows clients access to rich feature sets without
                    the maintenance burden that comes with the rapidly evolving
                    mobile landscape. Our scalable solutions can be deployed
                    onto your existing backend infrastructure or can be hosted
                    with our top tier partners Amazon, IBM, and Microsoft.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-6 approachSegments">
              <div className="row innerRow">
                <div className="col-md-6 approachSegment">
                  <img
                    src={require("../../assets/img/grow_meaningfully.png")}
                    alt="Icon"
                  />
                  <h3>MEANINGFUL INNOVATION</h3>
                  <p>
                    We are technologists and are fully engrossed in everything
                    mobile. Our fingers are on the code everyday embracing the
                    newest trends. We can help tailor your mobile strategy and
                    connect you to the newest innovations that will add
                    meaningful business value and enhance user experience. You
                    continue what you do best and leave the implementation to us
                  </p>
                </div>
                <div className="col-md-6 approachSegment">
                  <img
                    src={require("../../assets/img/grow_creatively.png")}
                    alt="Icon"
                  />
                  <h3>LOCAL TEAM</h3>
                  <p>
                    Our entire team is located in Newport Beach, CA. You will
                    personally get to know the developers on your project and
                    collaborate with them face to face. In addition, we teach at
                    the University of California Irvine and are involved with
                    various institutions on campus. This provides us access to
                    great talent, fosters the local community, and helps us keep
                    you up to date with emerging technologies.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
